import React from "react";
import ReactDOM from "react-dom";
import { Modal } from "react-bootstrap";

function ModalForm({ show, title, children, handleModal }) {  
  return ReactDOM.createPortal(
    <Modal
        show={show}
        onHide={()=>handleModal(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {children}
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={()=>handleModal(false)}>
            Cerrar
          </Button>
          <Button variant="primary">Guardar</Button>
        </Modal.Footer> */}
      </Modal>,
    document.getElementById("modal")
  );
}

export { ModalForm };
